module.exports = __webpack_public_path__ + "img/share_icon.12681154.png";